import { request } from '@utils/request/request';
import { RequestMethod } from '@utils/request/request.type';

import type { TicketDownloadStatus } from './use-get-ticket-download-status.type';

export const getTicketDownloadStatus = async (token: string): Promise<TicketDownloadStatus> => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/ticket/${token}/download-status`;
  return request({ url, method: RequestMethod.GET });
};
